<template>
	<div>
		<v-alert v-if="localData.userLoanModel != null" icon="mdi-shield-lock-outline" prominent text type="info">
			<v-row>
				<v-col cols="12" md="3">
					{{ localData.userLoanModel.loanModel.title }}
					<br>
					(شماره وام: {{ localData.userLoanModel.code }})
					<br>
					{{ localData.userLoanModel.amount.toString().toPriceFormat() }} تومان
				</v-col>
				<v-col cols="12" md="3">
					شروع:
					<br>
					{{ localData.userLoanModel.startDate_Persian.date }}
				</v-col>
				<v-col cols="12" md="3">
					{{ localData.userLoanModel.month }} قسط:
					<br>
					{{ localData.userLoanModel.installment.toString().toPriceFormat() }} تومان
				</v-col>
				<v-col cols="12" md="3">
					باقیمانده:
					<br>
					{{ localData.userLoanModel.remain.toString().toPriceFormat() }} تومان
				</v-col>
			</v-row>
		</v-alert>

		<v-form ref="form" class="mx-2" lazy-validation>
			<v-row>
				<v-col cols="12" md="6">
					<v-combobox v-model="localData.paymentMethod" clearable required :items="paymentMethods" label="نحوه پرداخت*" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" :rules="[() => !!localData.paymentMethod || 'نحوه پرداخت را انتخاب کنید']" />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-money ref="amount" v-model="localData.amount" :label="'*مبلغ پرداختی'" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ پرداختی را به صورت صحیح وارد کنید', () => localData.amount <= Math.max((localData.userLoanModel || {}).remain, 0) + initValue || 'مبلغ قسط از مبلغ باقیمانده نباید بیشتر باشد.']" required />
				</v-col>
			</v-row>
			<v-row v-if="localData.paymentMethod && localData.paymentMethod.id === 3">
				<v-col cols="12" md="6">
					<v-text-field ref="goldWeight" v-model="localData.goldWeight" :label="'وزن طلا'" :error-messages="errorMessages" :rules="[() => localData.goldWeight > 0 || 'وزن طلا را به صورت صحیح وارد کنید']" type="number" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-money ref="goldRate" v-model="localData.goldRate" :label="'قیمت واحد طلا'" :error-messages="errorMessages" :rules="[() => localData.goldRate > 0 || 'قیمت واحد طلا را به صورت صحیح وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-checkbox color="secondary" v-model="localData.isGoldCheckouted" label="طلا عودت داده شده" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<div>تاریخ سررسید</div>
						<date-picker ref="targetMonth" v-model="localData.targetMonth" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :disabled="!isNew" :rules="[() => !!localData.targetMonth || 'تاریخ سررسید را به صورت صحیح وارد کنید']" />
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<div>تاریخ واریز</div>
						<date-picker ref="saveDate" v-model="localData.saveDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[() => !!localData.saveDate || 'تاریخ واریز را به صورت صحیح وارد کنید']" />
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="description" v-model="localData.description" :label="'توضیحات'" :error-messages="errorMessages" />
				</v-col>

			</v-row>
		</v-form>
		<v-card-actions>
			<v-btn v-if="checkActivePart('thirdParty')" class="mx-1" fab dark small outlined color="pink" @click="() => { dialogThirdParty = true }" title="ارتباط با دیگر نرم افزار ها">
				<v-icon dark>
					mdi-apache-kafka
				</v-icon>
			</v-btn>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>

		<v-dialog v-model="dialogThirdParty" scrollable persistent>
			<v-card>
				<v-card-title>
					<span class="headline">ارتباط با دیگر نرم افزارها</span>
					<v-spacer />
					<v-btn @click="dialogThirdParty = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<thirdParty v-if="dialogThirdParty" @callbck="callbck_thirdParty" :entityType="'UserLoanPayment'" :entityId="localData.id" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get } from 'vuex-pathify'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyLoanPaymentView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'thirdParty': () => import('@/views/admin/ThirdParty.vue'),
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				dialogThirdParty: false,
				paymentMethods: [
					{ id: 1, title: 'نقدی' },
					{ id: 2, title: 'واریز بانکی' },
					{ id: 3, title: 'طلا' },
					{ id: 4, title: 'آنلاین' },
				],
				errorMessages: '',
				localData: { paymentMethod: { id: 1, title: 'نقدی' } },
				submitLoading: false,
				targetMonth: '',
				initValue: 0,
			}
		},
		computed: {
			isNew() {
				return this.localData.id === emptyId
			},
			...get('appSettings', [
				'settings',
			])
		},
		mounted() {
			this.prepareData()
		},
		methods: {
			async submit() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {}
				Object.assign(data, this.localData)
				if (this.settings.thanksPaymentSmsPattern) {
					var confirmSms = await this.$refs.confirm.open(
						'توجه',
						'آیا مایل به ارسال پیامک ثبت قسط به مشتری هستید؟',
					)
				}
				data.sendSms = !!confirmSms
				data.paymentMethod = this.localData.paymentMethod.id
				api.post('admin/loanpayment/SubmitPayment', data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId, paymentMethod: this.paymentMethods[0] }
				}
				if (!this.data.id) {
					this.data.paymentMethod = this.paymentMethods[0]
					this.data.id = emptyId
				}
				api.get('admin/loanpayment/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === emptyId)
								Object.assign(this.localData, this.data)
							else {
								this.initValue = response.amount
								this.localData.paymentMethod = this.paymentMethods.find(x => x.id == response.paymentMethod)
							}
							this.localData.userLoanModel = this.data.userLoanModel
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			callbck_thirdParty() {
				this.dialogThirdParty = false
			}
		},
	}
</script>
<style></style>
